
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/webinars/[slug]",
      function () {
        return require("private-next-pages/webinars/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/webinars/[slug]"])
      });
    }
  